import { Action, createReducer, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { ServicePercentageScheme } from './service-percentage-scheme.model';
import * as ServicePercentageSchemeActions from './service-percentage-scheme.actions';

export const servicePercentageSchemesFeatureKey = 'servicePercentageSchemes';

export interface State extends EntityState<ServicePercentageScheme> {
  // additional entities state properties
}

export const adapter: EntityAdapter<ServicePercentageScheme> = createEntityAdapter<ServicePercentageScheme>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export const reducer = createReducer(
  initialState,
  on(ServicePercentageSchemeActions.addServicePercentageScheme,
    (state, action) => adapter.addOne(action.servicePercentageScheme, state)
  ),
  on(ServicePercentageSchemeActions.upsertServicePercentageScheme,
    (state, action) => adapter.upsertOne(action.servicePercentageScheme, state)
  ),
  on(ServicePercentageSchemeActions.addServicePercentageSchemes,
    (state, action) => adapter.addMany(action.servicePercentageSchemes, state)
  ),
  on(ServicePercentageSchemeActions.upsertServicePercentageSchemes,
    (state, action) => adapter.upsertMany(action.servicePercentageSchemes, state)
  ),
  on(ServicePercentageSchemeActions.updateServicePercentageScheme,
    (state, action) => adapter.updateOne(action.servicePercentageScheme, state)
  ),
  on(ServicePercentageSchemeActions.updateServicePercentageSchemes,
    (state, action) => adapter.updateMany(action.servicePercentageSchemes, state)
  ),
  on(ServicePercentageSchemeActions.deleteServicePercentageScheme,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(ServicePercentageSchemeActions.deleteServicePercentageSchemes,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(ServicePercentageSchemeActions.loadServicePercentageSchemes,
    (state, action) => adapter.setAll(action.servicePercentageSchemes, state)
  ),
  on(ServicePercentageSchemeActions.clearServicePercentageSchemes,
    state => adapter.removeAll(state)
  ),
);

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
